import { HelpIfDifferentUrl } from 'feature/question/single-response-help';
import { component, componentWithVariants, demoFile, variant } from 'system/demo';

const comment = { key: '1', from: 'a', time: Date.now(), text: 'Comment', entryUrl: 'https://example.com/else' };

demoFile('feature/question/single-response-help');

componentWithVariants('HelpIfDifferentUrl', HelpIfDifferentUrl, { args: { comment } }, [
    variant('Different URL', { state: { globals: { entryUrl: 'https://example.com/here' } } }),
    variant('Same URL', { state: { globals: { entryUrl: 'https://example.com/else' } } }),
]);
